// #region CSS Styles
import "@splidejs/splide/dist/css/splide.min.css";
import "./assets/fonts/fonts.css";
import "./styles/main.css";
import "./styles/sass/index.scss";
import "./styles/layouts/blockgridlayout.css";
import "../css/index.css";
// #endregion

// #region 3rd Party Additions
import "flowbite";
import _, { map } from 'underscore';
import "./scripts/global/gsap.js";
// #endregion

// #region Navigation & Cookies
import "./scripts/global/navigation/navigation.js";
import "./scripts/global/navigation/masthead.js";
import "./scripts/global/cookie.js";
// #endregion

// #region Pages
import "./scripts/pages/comparePage.js";
import "./scripts/pages/eventsPage.js";
import "./scripts/pages/faqLandingPage.js";
import "./scripts/pages/knowledgeCenterPage.js";
import "./scripts/pages/mainChannelPage.js";
import "./scripts/pages/athletesPage.js"
import "./scripts/pages/boatResultsPage.js"
// #endregion

// #region Modules
import "./scripts/modules/marquee.js";
import "./scripts/modules/salesforceForms.js";
import "./scripts/modules/slide-in-content.js";
import "./scripts/modules/slide-up-darken.js";
import "./scripts/modules/hero-image-row.js";
import "./scripts/modules/vertical-carousel.js";
import "./scripts/modules/storyCardsGalleryOverflowRow.js";
import "./scripts/modules/dab-cta.js";
import "./scripts/modules/overflow-gallary.js";
import "./scripts/modules/slideUpFeatureCardsGallaryRow.js";
import "./scripts/modules/slideUpFeatureCardsComponentRow.js";
import "./scripts/modules/featureAccordionRow.js";
import "./scripts/modules/featureAccordionContainerRow.js";
import "./scripts/modules/featureOverflowVerticalScrollComponent.js";
import "./scripts/modules/boatsTabContainer.js";
import "./scripts/modules/boatFinder.js";
import "./scripts/modules/scrollingHeroBannerRow.js";
import "./scripts/modules/allBoats.js";
import "./scripts/modules/stickyNav.js";
import "./scripts/modules/input-slider.js";
import "./scripts/modules/google.map.js";
import "./scripts/modules/tab.js";
import "./scripts/modules/dealerLocator.js";
import "./scripts/modules/search.js";
import "./scripts/modules/heroBanner.js";
import "./scripts/modules/coPilotChat.js"
import "./scripts/modules/carousel.js";
import "./scripts/modules/modal-video.js";

// #endregion

// #region Exports
import { playPause } from "./scripts/modules/overflow-gallary.js";
import { showModal, showToolTip } from "./scripts/pages/comparePage.js";
export { openDialog } from "./scripts/modules/modal-video.js";
import { loadMoreStories } from "./scripts/pages/storiesPage.js";
export { updateToMobile } from "./scripts/modules/dab-cta.js";
import { updateActivity} from "./scripts/modules/allBoats.js";
export { navigateTo, onChickletClick } from "./scripts/global/navigation/navigation.js";

import { showAllManuals } from "./scripts/pages/ownersPage.js";
import { handleLoadMore } from "./scripts/pages/knowledgeCenterPage.js";
export { showEventModal, updateUrlParameter } from "./scripts/pages/eventsPage.js";
export { updateSelectedTab } from "./scripts/modules/tab.js";
export { updateAthleteList } from "./scripts/pages/athletesPage.js";

// #endregion
window.lib = {
  showModal,
  showToolTip,
  playPause,
  handleLoadMore,
  loadMoreStories,
  showAllManuals,
  updateActivity,
  
}

